import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { observer } from 'mobx-react-lite';
import { Text, Title } from '@/Components/Preferences/PreferencesComponents/Content';
import Button from '@/Components/Button/Button';
import { SyncQueueStrategy } from '@standardnotes/snjs';
import { StringGenericSyncError } from '@/Constants/Strings';
import { formatItemDate } from '@/Utils/LocalizedDateFormat';
import PreferencesGroup from '../../PreferencesComponents/PreferencesGroup';
import PreferencesSegment from '../../PreferencesComponents/PreferencesSegment';
import { c } from 'ttag';
const Sync = ({ application }) => {
    const [isSyncingInProgress, setIsSyncingInProgress] = useState(false);
    const lastSyncDate = formatItemDate(application.sync.getLastSyncDate());
    const doSynchronization = async () => {
        setIsSyncingInProgress(true);
        const response = await application.sync.sync({
            queueStrategy: SyncQueueStrategy.ForceSpawnNew,
            checkIntegrity: true,
        });
        setIsSyncingInProgress(false);
        if (response && response.error) {
            application.alerts.alert(StringGenericSyncError()).catch(console.error);
        }
    };
    const lastSyncSpan = _jsx("span", { className: "font-bold", children: c('B6.Preferences.Account.Info').t `on ${lastSyncDate}` });
    return (_jsx(PreferencesGroup, { children: _jsx(PreferencesSegment, { children: _jsx("div", { className: "flex flex-row items-center", children: _jsxs("div", { className: "flex flex-grow flex-col", children: [_jsx(Title, { children: c('B6.Preferences.Account.Title').t `Sync` }), _jsx(Text, { children: c('B6.Preferences.Account.Info').jt `Last synced ${lastSyncSpan}` }), _jsx(Button, { className: "mt-3 min-w-20", label: c('B6.Preferences.Account.Action').t `Sync now`, disabled: isSyncingInProgress, onClick: doSynchronization })] }) }) }) }));
};
export default observer(Sync);
